import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const SubmitSidingItelTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SUBMIT_SIDING_ITEL),
});
